import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { MetadataContainer } from '../entity/container';
import { EntityMetadata } from '../entity/entityMetadata';
import { DataService } from '../http/dataService';
import { Repository } from '../services/repository';

@Injectable({ providedIn: 'root' })
export class ConnectionPool {
  constructor(
    @Inject(ENV) private env: IEnvironment,
    private dataService: DataService
  ) {
    MetadataContainer.pool = this;
  }

  getMetadata(name: string): EntityMetadata {
    return MetadataContainer.entityMetadataList[name];
  }

  getRepository(target): Repository<any> {
    if (target.prototype instanceof Repository) {
      return new (target as any)(this.env, this.dataService);
    } else {
      return null;
    }
  }
}
